// ─────────────────────────────────────────────────────────────────────────────
// WelcomeSection.jsx 
// ─────────────────────────────────────────────────────────────────────────────

import { useEffect, useRef, useState } from 'react'
import Button from '@components/common/Button'
import { companyInfo } from '@data/companyInfo'

import aboutImg from '@assets/images/about/logo_Primary.png'
// const aboutImg = null

function useFadeIn() {
  const ref = useRef(null)
  const [vis, setVis] = useState(false)
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVis(true) }, { threshold: 0.15 })
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [])
  return [ref, vis]
}

const CHECK_POINTS = [
  'Science-driven, performance-focused solutions',
  'Premium inputs from internationally recognized manufacturers',
  'Serving poultry, dairy & ruminant production systems',
  'Technical guidance, training & responsive expert support',
  'Regulatory compliant & sustainably focused',
]

const CheckIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ flexShrink: 0 }}>
    <circle cx="9" cy="9" r="9" fill="#007935"/>
    <path d="M4.5 9L7.5 12L13.5 6" stroke="white" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default function WelcomeSection() {
  const [ref, vis] = useFadeIn()

  return (
    <section style={{ background: '#ffffff', padding: '80px 0' }}>
      <div style={{
        maxWidth: 'var(--container-max)',
        margin:   '0 auto',
        padding:  '0 var(--container-padding)',
      }}>
        <div
          ref={ref}
          style={{
            display:             'grid',
            gridTemplateColumns: '1fr 1fr',
            gap:                 '72px',
            alignItems:          'center',
          }}
          className="welcome-grid"
        >

          {/* ── LEFT: Text ── */}
          <div style={{
            opacity:    vis ? 1 : 0,
            transform:  vis ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s ease',
          }}>
            {/* Section tag — MIAVIT style: just color, no pill */}
            <p style={{
              fontFamily:    "'DM Sans', sans-serif",
              fontSize:      'clamp(1.75rem, 3vw, 2.1rem)',
              fontWeight:    500, color: '#1a1a18',
              letterSpacing: '0.04em', textTransform: 'uppercase',
              color:         '#007935', margin: '0 0 6px',          
              margin:      '0 0 16px',
            }}>
              Welcome to Salient Agrinutrition
            </p>



            <p style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize:   '1rem', color: '#55544e',
              lineHeight: 1.75, margin: '0 0 14px',
            }}>
              {companyInfo.description}
            </p>

            <p style={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize:   '1rem', color: '#55544e',
              lineHeight: 1.75, margin: '0 0 28px',
            }}>
              Our solutions deliver measurable improvements in feed efficiency, growth rates,
              reproductive performance, immunity, and overall herd and flock productivity.
            </p>

            {/* Checklist 
            <div style={{ marginBottom: '32px' }}>
              {CHECK_POINTS.map((pt, i) => (
                <div key={i} style={{
                  display:     'flex', alignItems: 'flex-start', gap: '10px',
                  marginBottom:'10px',
                  opacity:     vis ? 1 : 0,
                  transform:   vis ? 'translateX(0)' : 'translateX(-12px)',
                  transition:  `all 0.4s ease ${0.15 + i * 0.08}s`,
                }}>
                  <CheckIcon />
                  <span style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize:   '14px', color: '#44443e', lineHeight: 1.55,
                  }}>
                    {pt}
                  </span>
                </div>
              ))}
            </div>*/}

            <Button variant="secondary" to="/about">
              Read more about Salient
            </Button>
          </div>

          {/* ── RIGHT: Image ── */}
          <div style={{
            opacity:    vis ? 1 : 0,
            transform:  vis ? 'translateY(0)' : 'translateY(20px)',
            transition: 'all 0.6s ease 0.15s',
            aspectRatio:'4/3',
            overflow:   'hidden',
            background: aboutImg ? 'transparent'
              : 'linear-gradient(135deg, #065e32 0%, #007935 60%, #0db374 100%)',
          }}>
            {aboutImg
              ? <img src={aboutImg} alt="Salient Agrinutrition"
                  style={{ width:'100%', height:'100%', objectFit:'contain' }} />
              : (
                <div style={{
                  width:'100%', height:'100%',
                  display:'flex', flexDirection:'column',
                  alignItems:'center', justifyContent:'center', gap:'12px',
                }}>
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
                    stroke="rgba(255,255,255,0.3)" strokeWidth="1" strokeLinecap="round">
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <circle cx="8.5" cy="8.5" r="1.5"/>
                    <polyline points="21 15 16 10 5 21"/>
                  </svg>
                  <p style={{ fontFamily:"'DM Sans',sans-serif", fontSize:'12px',
                    color:'rgba(255,255,255,0.4)', margin:0 }}>
                    Place image at: src/assets/images/about/about-home.jpg
                  </p>
                </div>
              )
            }
          </div>

        </div>
      </div>

      <style>{`
        @media (max-width: 767px) {
          .welcome-grid { grid-template-columns: 1fr !important; gap: 36px !important; }
        }
      `}</style>
    </section>
  )
}